<template>
  <el-tooltip :content="$t('inspector_teams.join.btnTooltip')"
              effect="light"
              :open-delay="300"
              placement="bottom">
    <base-button block type="primary" class="m-0" @click.native="handleJoinInspectorTeam()" :loading="updating">
      {{ $t('inspector_teams.join.btnLbl') }}
    </base-button>
  </el-tooltip>
</template>

<script>
  import {mapActions, mapState} from "vuex";
  import swal from "sweetalert2";

  export default {
    name: "JoinInspectorTeamBtn",
    props: {
      details: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState({
        updating: state => state.inspector_teams.updating,
        error: state => state.inspector_teams.error,
      }),
    },
    methods: {
      ...mapActions(['JoinInspectorTeam', 'LoadInspectorTeamMembers']),
      handleJoinInspectorTeam() {
        swal({
          title: this.$t('inspector_teams.join.text'),
          text: `'${this.details.name}'`,
          confirmButtonText: this.$t('inspector_teams.join.actionBtnLabel'),
          cancelButtonText: this.$t('inspector_teams.join.cancelBtnLabel'),
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary',
          cancelButtonClass: 'btn btn-secondary',
          type: 'question',
          showCancelButton: true
        }).then(result => {
          if (result.value) {
            this.JoinInspectorTeam(this.details.id).then(() => {
              if (this.error == null) {
                // Refresh token and user data after joining inspector team.
                this.$auth.refresh();
                this.$auth.fetch();

                this.$notify({
                  type: 'success',
                  message: this.$t('inspector_teams.join.joinedNotification', {
                    name: this.details.name
                  }),
                  icon: 'tim-icons icon-alert-circle-exc'
                })
                this.LoadInspectorTeamMembers(this.details.id)
              }

            })
          }
        });
      },
    }
  }
</script>

<style scoped>

</style>
